import { CSSProperties, ImgHTMLAttributes } from 'react';

export type ImagePlaceholder = 'blur' | 'empty';

export interface ImageProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'loading' | 'placeholder'> {
  src: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  style?: CSSProperties;
  className?: string;
  loading?: 'lazy' | 'eager';
  /** Next.js parity — when true, sets loading="eager". */
  priority?: boolean;
  placeholder?: ImagePlaceholder;
  blurDataURL?: string;
  fill?: boolean;
  sizes?: string;
  quality?: number;
  loader?: unknown;
  unoptimized?: boolean;
}

export default function Image({
  src,
  alt,
  width,
  height,
  style,
  className,
  loading = 'lazy',
  priority,
  placeholder: _placeholder,
  blurDataURL: _blurDataURL,
  fill: _fill,
  sizes,
  quality: _quality,
  loader: _loader,
  unoptimized: _unoptimized,
  ...rest
}: ImageProps) {
  return (
    <img
      src={src}
      alt={alt ?? ''}
      width={width}
      height={height}
      style={style}
      className={className}
      loading={priority ? 'eager' : loading}
      sizes={sizes}
      {...rest}
    />
  );
}
